/*
 * GameApplyInfo 不同于 TeamApply，此处除了处理队伍管理，还承接了流程管理的功能
 */
import React from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { inject, observer } from "mobx-react";
import TeamInfo from "../../common/teamInfo";
import SubmitLimitTip from "../submitLimitTip";
import GameInfo from "../../game/gameInfo";
import Modal from "../../modal/modal";
import { Button, Col, Row, Spin, message } from "antd";
import Language from "../../language/language";
import CheckErrorInfo from "../../common/checkErrorInfo";
import { $const, $util } from "../../../helper";
import { Modal as ModalAntd } from "antd";

import "../stylesheets/gameApplyInfo.scss";
import agent from "../../../agent";

@inject("teamStore", "authStore", "gameStore", "languageStore", "commonStore")
@observer
@withRouter
export default class GameApplyInfo extends React.Component {
  intervalTag = null;
  state = {
    isEditing: false,
    isLoading: false,
    registerButtonLoading: false,
    showCheckModal: false,
    checkErrorInfo: [],
    submitIsLoading: false,
    nextBtnLoading: false
  };
  componentWillUnmount() {
    this.intervalTag && clearInterval(this.intervalTag);
  }
  componentDidMount() {
    if (!this.props.match.params.id) {
      this.props.history.push("/control-center");
    } else {
      this.setState({
        isLoading: true
      });
      this.props.teamStore.getTeamInfo(this.props.match.params.id).finally(() => {
        if (
          this.props.teamStore.teamInfo.status === $const.TEAM_STATUS.EDIT ||
          this.props.teamStore.teamInfo.status === $const.TEAM_STATUS.UNLOCKED
        ) {
          //战队为可编辑状态时 点开战队详情默认是打开编辑状态
          this.setState({
            isEditing: true
          });
        }
        this.setState({
          isLoading: false
        });
      });
    }
    this.intervalTag = setInterval(this.initFetch, 10 * 1000);
  }

  initFetch = () => {
    this.props.teamStore.getTeamInfo(this.props.match.params.id).finally(() => {
      if (
        this.props.teamStore.teamInfo.status === $const.TEAM_STATUS.EDIT ||
        this.props.teamStore.teamInfo.status === $const.TEAM_STATUS.UNLOCKED
      ) {
        //战队为可编辑状态时 点开战队详情默认是打开编辑状态
        this.setState({
          isEditing: true
        });
      }
      this.setState({
        isLoading: false
      });
    });
  };

  verifyPerson = async () => {
    const userId = this.props.authStore.user && this.props.authStore.user.id;
    const gameId = this.props.teamStore.teamInfo && this.props.teamStore.teamInfo.eventId;
    const teamId = this.props.teamStore.teamInfo && this.props.teamStore.teamInfo.id;
    const checkRes = await $util.verifyPersonalInfo(userId, gameId, teamId, "4");
    if (checkRes && checkRes.data && checkRes.data.result === 1) {
      return true;
    }
    if (checkRes && checkRes.data && checkRes.data.res && checkRes.data.res.length > 0) {
      this.setState({
        checkErrorInfo: checkRes.data.res
      });
    }
    return false;
  };

  showConfirmTip = () => {
    this.props.commonStore.gTag("event", "confirmApplyGame", {
      pageName: "gameApplyInfo",
      buttonName: "确认报名"
    });
    // 检验队伍是否符合比赛要求
    if (
      $util.checkTeamMembers(this.props.teamStore.teamInfo) &&
      $util.checkTeamInfo(this.props.teamStore.teamInfo)
    ) {
      // 提示即将锁定队伍
      this.props.gameStore.showGameRegistration();
    } else {
      // 不符合要求
      this.props.gameStore.showTeamMemberMissing();
    }
  };

  showSubmitTeamInfoTip = () => {
    ModalAntd.confirm({
      iconType: "exclamation-circle",
      title: this.props.languageStore.getResource(
        this.props.languageStore.lang,
        "CONFIRM_MEMBER_TIP_TITLE"
      ),
      content: this.props.languageStore.getResource(
        this.props.languageStore.lang,
        "CONFIRM_MEMBER_TIP"
      ),
      okText: this.props.languageStore.getResource(
        this.props.languageStore.lang,
        "KICK_OUT_CONFIRM"
      ),
      cancelText: this.props.languageStore.getResource(
        this.props.languageStore.lang,
        "KICK_OUT_CANCEL"
      ),
      onOk: this.verifyTeamInfo
    });
  };

  // 校验队伍资料
  verifyTeamInfo = async () => {
    this.setState({
      submitIsLoading: true,
      registerButtonLoading: true
    });
    const res = await this.verifyPerson();
    if (res) {
      // 校验通过，锁定当前队伍。
      this.lockCurTeam();
    } else {
      // 校验失败，提示错误信息。
      this.setState({
        showCheckModal: !res,
        submitIsLoading: false,
        registerButtonLoading: false
      });
    }
  };

  // 锁定当前队伍
  lockCurTeam = () =>
    this.props.teamStore
      .lockTeam({
        variables: {
          input: {
            id: this.props.teamStore.teamInfo.id
          }
        }
      })
      .then(() => {
        this.setState({
          isEditing: false
        });
        // 没有报名则报名
        if (!this.props.teamStore.registrationId) {
          this.fetchToRegister();
        } else {
          this.setState({
            registerButtonLoading: false,
            submitIsLoading: false
          });
        }
      });

  // 团队赛报名
  fetchToRegister = () => {
    this.props.gameStore
      .registration({
        variables: {
          input: {
            attributes: {
              eventId: this.props.teamStore.teamInfo.gevent.id,
              sourceType: $const.SOURCE_TYPE.TEAM,
              sourceId: this.props.teamStore.teamInfo.id,
              flowId: this.props.teamStore.teamInfo.myFlow.id
            }
          }
        }
      })
      .then(async () => {
        await this.props.teamStore.lockTeam({
          variables: {
            input: {
              id: this.props.teamStore.teamInfo.id
            }
          }
        });
        // 之前 registrationId 不存在，需要重新设置并保留原来表单的其他数据
        const oldGameForm = this.props.gameStore.gameForm;
        const oldInput = oldGameForm && oldGameForm.variables && oldGameForm.variables.input;
        if (oldInput) {
          this.props.gameStore.setGameForm(
            {
              variables: {
                input: {
                  ...oldInput,
                  registrationId: this.props.gameStore.gameRegistrationId
                }
              }
            },
            this.props.gameStore.gameFormSuccessCallback
          );
        }
        this.setState({
          registerButtonLoading: false,
          submitIsLoading: false
        });
        // 提交报名表单信息
        message.success(
          this.props.languageStore.getResource(this.props.languageStore.lang, "UPDATE_SUCCESS")
        );
        this.closeConfirmTip();
      });
  };

  closeModal = () => {
    this.setState({
      showCheckModal: false
    });
  };

  submit = () => {
    // 锁定成功之后提交表单
    this.props.gameStore.formSubmit().then(() => {
      this.props.teamStore.getTeamInfo(this.props.match.params.id);
    });
  };

  closeConfirmTip = () => {
    this.props.gameStore.closeGameRegistration();
  };
  closeTeamMemberMissing = () => {
    this.props.gameStore.closeTeamMemberMissing();
  };

  renderTeamMemberTip = () => {
    const teamInfo = this.props.teamStore.teamInfo;
    const lang = this.props.languageStore.lang;
    return (
      <ul>
        <li>
          <Language resource="TEAM_MEMBER_REQUIRED" />
        </li>
        <li>
          <Language resource="TEAM_MEMBER_REQUIRED_1" />
        </li>
        {teamInfo.positionLimit.length > 0 &&
          teamInfo.positionLimit.map((position, index) => {
            if (position.min === undefined || position.max === undefined) {
              return null;
            }
            let name = "";
            position.eventPositions &&
              position.eventPositions.length > 0 &&
              position.eventPositions.forEach((item, index) => {
                if (item && item.eventPosition && item.eventPosition.position) {
                  name += `${index > 0 ? "+" : ""}${
                    item.eventPosition.position.nameUuidI18n[lang]
                  }`;
                }
              });
            return (
              <li key={position.id}>
                {lang === "zh" ? (
                  <span>
                    {index + 2}、{name}人数为{position.min}-{position.max};
                  </span>
                ) : (
                  <span>
                    There must be {position.min}-{position.max} teacher-mentors{" "}
                  </span>
                )}
              </li>
            );
          })}
      </ul>
    );
  };

  submitLimitForm = () => {
    this.props.gameStore
      .formSubmit()
      .then(() => {
        this.props.teamStore.getTeamInfo(this.props.teamStore.teamInfo.id);
      })
      .finally(() => {
        this.closeSubmitLimitModal();
        this.props.gameStore.submitButtonStateLoading();
        setTimeout(() => {
          this.props.gameStore.submitButtonStateNormal();
        }, 3000);
      });
  };

  closeSubmitLimitModal = () => {
    this.props.gameStore.clearSubmitLimit();
  };

  handleNext = async () => {
    if (this.state.nextBtnLoading) return;
    this.setState({
      nextBtnLoading: true
    });
    try {
      const res = await agent.SassPlatform.updateCollectionProcessState(
        this.props.teamStore.teamInfo.id,
        this.props.teamStore.collectionStrategyId,
        {
          // 是否已经确认参赛信息
          confirmTeamInfo: true,
          submitPreEntryList: false
        }
      );
      if (res && res.success && res.data) {
        // 在提交参赛名单阶段，需要跳转
        $util.openTeamSubmitEntryListPage({
          teamId: this.props.teamStore.teamInfo.id,
          lang: this.props.languageStore.lang,
          bbsTeamId: this.props.teamStore.teamInfo.bbsTeamId,
          eventId: this.props.teamStore.teamInfo.gevent.id,
          collectionId: this.props.teamStore.collectionId
        });
      } else {
        message.error(
          this.props.languageStore.lang === "zh"
            ? "提交失败，请重试！"
            : "Update failed, please try again later."
        );
      }
    } catch (error) {
      console.error(error);
      message.error(
        this.props.languageStore.lang === "zh"
          ? "提交失败，请重试！"
          : "Update failed, please try again later."
      );
    }
    this.setState({
      nextBtnLoading: false
    });
  };

  render() {
    const teamInfo = this.props.teamStore.teamInfo;
    if (!teamInfo || !teamInfo.id || !this.props.authStore.user.id) {
      return <div className="game-apply-info"></div>;
    }
    if (this.state.isLoading) {
      return (
        <div className="game-apply-info empty">
          <Spin />
        </div>
      );
    }
    const gameInfo = teamInfo.myFlow;
    const stageIdMajorNum = teamInfo.stageIdMajorNum;
    const lang = this.props.languageStore.lang;
    const gameData = teamInfo.gameData;
    const stageId = teamInfo.stageId;
    // 是否已经报过名
    const registered = !!this.props.teamStore.registrationId;
    const isEditing = this.state.isEditing;
    const currentTeamIsSpecialGame = this.props.teamStore.currentTeamIsSpecialGame;
    const showCollectionStage = this.props.teamStore.showCollectionStage;

    return (
      <div
        data-perf
        className="game-apply-info"
        data-log={$util.log({
          pageId: "gameApplyInfo",
          matchId: gameInfo.eventId
        })}
      >
        {teamInfo.isComplete ? (
          <div className="is-completed">
            <Language resource="IS_COMPLETED" />
          </div>
        ) : null}
        <TeamInfo info={teamInfo} isEditing={isEditing} />
        {/* 提交对队伍修改，队长与副队长均有权提交，且学校信息通过校验才可提交确认信息 */}
        {!currentTeamIsSpecialGame && isEditing && (teamInfo.isCaptain || teamInfo.isSubCaptain) ? (
          <div className="submit-edit-member-wrapper">
            <Button
              disabled={!this.props.allInfoIsLegal}
              type="primary"
              loading={this.state.submitIsLoading}
              onClick={registered ? this.showSubmitTeamInfoTip : this.showConfirmTip}
            >
              <Language resource={registered ? "CONFIRM_INFO" : "APPLY_GAME"}></Language>
            </Button>
            <p className="confirm-member-warn">
              <Language resource="CONFIRM_MEMBER_WARN"></Language>
            </p>
          </div>
        ) : null}
        {currentTeamIsSpecialGame ? (
          !showCollectionStage && (
            <Language
              className="game-apply-info__entryListTips"
              resource="ENTRY_LIST_TIPS"
            ></Language>
          )
        ) : (
          <Language
            className="game-apply-info__entryListTips"
            resource="ENTRY_LIST_TIPS"
          ></Language>
        )}
        {/* UC和UL且当前环节为收集名单不展示表单 */}
        {currentTeamIsSpecialGame ? (
          !showCollectionStage ? (
            // 队长和副队长有权限提交流程环节里的信息，副队长不能提交测评环节里的东西
            <GameInfo
              gameType={$const.SOURCE_TYPE.TEAM}
              canSubmit={teamInfo.isCaptain || teamInfo.isSubCaptain}
              stageIdMajorNum={stageIdMajorNum}
              stageId={stageId}
              gameData={gameData}
              gameInfo={gameInfo}
            />
          ) : (
            <div />
          )
        ) : (
          <GameInfo
            gameType={$const.SOURCE_TYPE.TEAM}
            canSubmit={teamInfo.isCaptain || teamInfo.isSubCaptain}
            stageIdMajorNum={stageIdMajorNum}
            stageId={stageId}
            gameData={gameData}
            gameInfo={gameInfo}
          />
        )}
        {currentTeamIsSpecialGame && showCollectionStage ? (
          <Row type="flex" align="middle" justify="end">
            <Col style={{ marginRight: 48, marginTop: 48 }}>
              <Button
                onClick={this.handleNext}
                type="primary"
                loading={this.state.nextBtnLoading}
                disabled={!this.props.allInfoIsLegal}
              >
                <Language resource="NEXT"></Language>
              </Button>
            </Col>
          </Row>
        ) : null}
        {currentTeamIsSpecialGame && showCollectionStage ? (
          <Language className="collectionListNextTips" resource="COLLECTION_LIST_NEXT_TIPS" />
        ) : null}
        <div className="operate">
          <Link className="back-control-center" to="/control-center">
            <Language resource="RETURN_CONTROL_CENTER" />
          </Link>
        </div>
        {/* 提示报名的队伍锁定 */}
        <Modal
          className="model-confirm-tip"
          title={<Language resource="CONFIRM_SUBMIT" />}
          state={this.props.gameRegistrationModal}
          close={this.closeConfirmTip}
        >
          <div className="confirm-tip">
            {this.props.languageStore
              .getResource(lang, "CONFIRM_TIP")
              .replace("XXX", teamInfo.gevent && teamInfo.gevent.titleUuidI18n[lang])}
          </div>
          <div className="operate">
            <Button
              disabled={this.state.registerButtonLoading}
              loading={this.state.registerButtonLoading}
              onClick={this.verifyTeamInfo}
            >
              <Language resource="CONFIRM" />
            </Button>
          </div>
        </Modal>
        <Modal
          title={<Language resource="TEAM_MEMBER_MISSING_TITLE" />}
          state={this.props.gameStore.teamMemberMissingModal}
          close={this.closeTeamMemberMissing}
        >
          <div className="confirm-tip">{this.renderTeamMemberTip()}</div>
          <div className="operate">
            <Button onClick={this.closeTeamMemberMissing}>
              <Language resource="CONFIRM" />
            </Button>
          </div>
        </Modal>
        {/* 信息校验不通过，展示错误信息 */}
        <Modal
          title={<Language resource="PERSONAL_INFO_NOT_CHECKED" />}
          state={this.state.showCheckModal && this.state.checkErrorInfo.length > 0}
          close={this.closeModal}
          className="game-apply__modal-box"
        >
          <CheckErrorInfo checkErrorInfo={this.state.checkErrorInfo} />
          <Button
            className="game-apply__modal-btn"
            type="primary"
            htmlType="submit"
            onClick={this.closeModal}
          >
            <Language resource="CONFIRM" />
          </Button>
        </Modal>
        {this.props.gameStore.submitLimit ? (
          <SubmitLimitTip submit={this.submitLimitForm} close={this.closeSubmitLimitModal} />
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/controlCenter/gameApply/gameApplyInfo.js